import React, { useState } from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import { Element } from 'react-scroll'
import { PointTitle } from '../atoms/pointtitle'
import { TextCard } from '../molecules/text_card'

export const PointAlignerView = () => {

  const cards: { title: string, description: string }[] = [
    { title: "効率", description: "1週間の期間で2枚のアライナー（αアライナー：3日間・βアライナー：4日間）を装着するため、矯正力を低下させず、より早く目的の位置まで歯牙を移動させることが可能です。" },
    { title: "快適", description: "各Stepで歯牙の痛みを軽減させるために、痛みが起きづらいαアライナーを経て歯牙を力強く動かすβアライナーの装着をいたします。" },
    { title: "衛生", description: "hanaloveのアライナーは、短期間でアライナーを交換するため、アライナー1枚あたりの装着時間を大幅に短縮させ、口腔衛生状態の維持に役立ちます。" },
  ]
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section className="content">
      <Element name="page-aligner" className="content--standard pointalignerview">
        <PointTitle>アライナーの特徴</PointTitle>
        <section className="pointalignerview--listArea">
          {cards.map((card, index) => (
            <TextCard
              key={index}
              index={index}
              openIndex={openIndex}
              title={card.title}
              description={card.description}
              onClick={() => setOpenIndex(index === openIndex ? null : index)}
            />
          ))}
        </section>
      </Element>
    </section>
  )
}